define('app/factories/newsletter_popup_factory',['app/setup', 'app/models/subscriber', 'app/views/newsletter_popup_view'],
  function(takhfifan, subscriber, dummy_view) {
    return {};
    var $box = $('.tkh-newsletter-box');
    if ($box.length > 0) {
      return new takhfifan.NewsletterPopupView({
        el: $box,
        model: new takhfifan.Subscriber(),
      });
    }
    else {
      return {};
    };
});

